import { AgentUsageColumn } from "@common/types/views/agentUsageView";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { ViewConfig } from "@lib/views";
import { AgentUsageRow } from "./agentUsageRow";
import { LastActivityCell } from "./cells/LastActivityCell";
import { NumberCell } from "./cells/NumberCell";
import { ShareCell } from "./cells/ShareCell";
import { UsageClientCell } from "./cells/UsageClientCell";

export const agentUsageViewConfig: ViewConfig<
    AgentUsageRow,
    AgentUsageColumn,
    never
> = {
    columns: {
        [AgentUsageColumn.CLIENT]: {
            accessorKey: "name",
            name: "Client",
            header: "Client",
            cell: UsageClientCell,
            immutable: true,
            minSize: 200,
            maxSize: 400,
        },
        [AgentUsageColumn.LAST_ACTIVITY]: {
            accessorKey: "lastActivityAt",
            name: "Last activity",
            header: "Last activity",
            cell: LastActivityCell,
            ...DATE_COLUMN_SIZE,
        },
        [AgentUsageColumn.FREE_TOKENS]: {
            accessorKey: "freeTokens",
            name: "Free tokens used",
            header: "Free tokens used",
            cell: NumberCell,
            minSize: 140,
            maxSize: 200,
        },
        [AgentUsageColumn.PAID_TOKENS]: {
            accessorKey: "paidTokens",
            name: "Paid tokens used",
            header: "Paid tokens used",
            cell: NumberCell,
            minSize: 140,
            maxSize: 200,
        },
        [AgentUsageColumn.SHARE_OF_USAGE]: {
            accessorKey: "shareOfUsage",
            name: "Share of usage",
            header: "Share of usage",
            cell: ShareCell,
            minSize: 120,
            maxSize: 160,
        },
        [AgentUsageColumn.TASKS]: {
            accessorKey: "tasksCount",
            name: "Tasks",
            header: "Tasks",
            cell: NumberCell,
            minSize: 100,
            maxSize: 140,
        },
    },
};
